import { useEffect, useState } from "react";
import { BiLogoDevTo } from "react-icons/bi";
import { SiHashnode } from "react-icons/si";
import "./blog.css";
import { fetchBlogs } from "./fetchBlogs";

const Blogs = () => {
  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const blogsData = await fetchBlogs();
      setBlogs(blogsData);
    };
    fetchData();
  }, []);

  return (
    <div>
      <h1 className="artHead fadeRight">Blogs I've authored</h1>
      <div className="artLinks fadeLeft">
        <a href="https://sonubardai.hashnode.dev/" className="artLink" target="_blank" rel="noreferrer">
          <span>Hashnode</span>
          <SiHashnode className="artIcon" />
        </a>
        <a href="https://dev.to/sonubardai" className="artLink" target="_blank" rel="noreferrer">
          <span>Dev.to</span>
          <BiLogoDevTo className="artIcon" />
        </a>
      </div>
      <div className="blogs">
        {blogs.length > 0 ? (
          blogs.map((blog) => (
            <div key={blog.url} className="blog-card">
              {blog.coverImage && <img src={blog.coverImage} alt={blog.title} />}
              <h2>{blog.title}</h2>
              <p>{blog.brief || blog.description}</p>
              <a href={blog.url} target="_blank" rel="noreferrer">
                Read more
              </a>
            </div>
          ))
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};

export default Blogs;
